/************
 * Developed by : Shiva Software Solutions
 * Date : 14-06-2021
 * Descriptions : Route for dahboard page
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const pharmacyConfigs = [
  {
    auth: authRole.userPhar,
    routes: [
      {
        path: '/pharmacy',
        component: React.lazy(() =>
          import('../pharmAssistPage/pharmacy/PrescriptionsPage'),
        ),
      },
    ],
  },
  {
    auth: authRole.userPhar,
    routes: [
      {
        path: '/sarvodhayaPharmacy',
        component: React.lazy(() =>
          import('../pharmAssistPage/pharmacy/PharmacyCartPage'),
        ),
      },
    ],
  },
  {
    auth: authRole.userPhar,
    routes: [
      {
        path: '/pharmacydispenced',
        component: React.lazy(() =>
          import('../pharmAssistPage/pharmacy/DispensedListPage'),
        ),
      },
    ],
  },
  {
    auth: authRole.userPhar,
    routes: [
      {
        path: '/sarvopharmacydispenced',
        component: React.lazy(() =>
          import('../pharmAssistPage/pharmacy/PharmacyDispensedListPage'),
        ),
      },
    ],
  },
  {
    auth: authRole.userPhar,
    routes: [
      {
        path: '/pharmacyCallBackList',
        component: React.lazy(() =>
          import('../pharmAssistPage/callbackList/index'),
        ),
      },
    ],
  },
];
